import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Colaborador } from '../Modelos/Colaborador';

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionEnlacesService {
  constructor() { }

  async consultarColaborador(codigoColaborador: number) {
    let url=new URL(`${environment.backendUrl}/api/ParametrizacionEnlace/ConsultarColaborador`);
    let parameters={
      IN_CodColaborador: codigoColaborador
    };
    Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
    return await (await fetch(url.toString(), {method: 'GET'})).json();
  }

  async consultarAplicacionesColaborador(in_CodColaborador: number) {
    let url=new URL(`${environment.backendUrl}/api/ColaboradorApliacion/ConsultarApliacionesColaborador`);
    let parameters={
      IN_CodColaborador: in_CodColaborador
    };
    Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
    return await (await fetch(url.toString(), {method: 'GET'})).json();
  }

  async consultarColaboradores(claveIntermediario: number, tipoIntermediario: number) {
    let url=new URL(`${environment.backendUrl}/api/ParametrizacionEnlace/ConsultaColaboradoresAsociados`);
    let parameters={
      IN_Usu_login: claveIntermediario,
      IN_Usu_tipo: tipoIntermediario
    };
    Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
    return await (await fetch(url.toString(), {method: 'GET'})).json();
  }

  async actualizarAplicacion(
    idColaborador: number,
    claveIntermediario: number,
    tipoIntermediario: number,
    codigoAplicacion: number,
    esPrimeraAplicacion: boolean){
    let url=new URL(`${environment.backendUrl}/api/ColaboradorApliacion/ActualizarApliacionesColaborador`);
    let parameters={
      IN_CodColaborador: idColaborador,
      IN_Usu_login: claveIntermediario,
      IN_Usu_tipo: tipoIntermediario,
      IN_CodApliacion: codigoAplicacion,
      SN_Actualiza: (esPrimeraAplicacion)?-1:0
    };
    Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
    return await (await fetch(url.toString(), {method: 'GET'})).json();
  }

  async guardarColaborador(colaborador: Colaborador, flagNuevoColaborador: boolean){
    let url=`${environment.backendUrl}/api/ParametrizacionEnlace/${(flagNuevoColaborador)?"RegistroColaborador":"ActualizarColaborador"}`;
    let data={
      "IN_CodColaborador": (!colaborador.in_CodColaborador)?0:colaborador.in_CodColaborador,
      "IN_Usu_login": colaborador.in_Usu_login,
      "IN_Usu_tipo": colaborador.in_Usu_tipo,
      "IN_Cod_tipo_doc":   (!colaborador.in_Cod_tipo_doc)?0:colaborador.in_Cod_tipo_doc,
      "VC_Nro_documento": colaborador.vc_Nro_documento.toString(),
      "VC_ApellidoUno": colaborador.vc_ApellidoUno,
      "VC_ApellidoDos": (!colaborador.vc_ApellidoDos)?"":colaborador.vc_ApellidoDos,
      "VC_NombreUno": colaborador.vc_NombreUno,
      "VC_NombreDos": (!colaborador.vc_NombreDos)?"":colaborador.vc_NombreDos,
      "VC_Email": (!colaborador.vc_Email)?"":colaborador.vc_Email,
      "VC_Contrasena":  (!colaborador.vc_Contrasena)?"":colaborador.vc_Contrasena,
      "IN_Estado": (colaborador.estado)?1:0,
      "IN_SnRecClave": (!colaborador.in_SnRecClave)?1:colaborador.in_SnRecClave,
      "VcCod_UsuarioSISE": (!colaborador.vcCod_UsuarioSISE)?"":colaborador.vcCod_UsuarioSISE,
      "IN_Sn_registro_colaborador":  (flagNuevoColaborador) ? 1 : 0
    };
    let json=JSON.stringify(data);

    let request: RequestInit={
      headers: {
        'Accept': "application/json",
        'Content-Type': "application/json;charset=utf-8"
      },
      body: json,
      method: 'POST'
    }
    return await (await fetch(url.toString(), request)).json();
  }

  async consultarAplicaciones() {
    let url=`${environment.backendUrl}/api/ColaboradorApliacion/ConsultarAplicaciones`;
    return await (await fetch(url, {method: 'GET'})).json();   
  }
}